export const endpoints = {
  fetchProductsBySku: () => ({
    url: 'catalog/products-by-sku',
  }),
  fetchCatalogProducts: () => ({
    url: 'v3/catalog/products',
  }),
}
